import TYPES from '@/modules/shared/types';

// Domain
import { PeriodicityOfContributionRepository } from '../../domain/repository';
import {
  PeriodicityOfContributionEntity,
} from '../../domain/entities/periodicity-of-contribution-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class PeriodicityOfContributionHttpRepository
implements PeriodicityOfContributionRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/allianz/periodicity-of-contribution/`;

  execute(): Promise<Array<PeriodicityOfContributionEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({
              data,
              success,
              message,
            }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
